function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Br\xEDet",
  transform: "translate(-1531.000000, -3036.000000)",
  fill: "#88949D",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "facebook.2",
  transform: "translate(1531.000000, 3036.000000)"
}, React.createElement("path", {
  d: "M8,24.002 L5,24.002 C4.724,24.002 4.5,23.778 4.5,23.502 L4.5,13.002 L1,13.002 C0.724,13.002 0.5,12.778 0.5,12.502 L0.5,9.502 C0.5,9.226 0.724,9.002 1,9.002 L4.5,9.002 L4.5,5.502 C4.5,2.469 6.968,0.002 10,0.002 L13,0.002 C13.276,0.002 13.5,0.226 13.5,0.502 L13.5,3.502 C13.5,3.778 13.276,4.002 13,4.002 L10,4.002 C9.173,4.002 8.5,4.675 8.5,5.502 L8.5,9.002 L13,9.002 C13.161,9.002 13.312,9.079 13.405,9.21 C13.5,9.34 13.525,9.508 13.474,9.661 L12.474,12.661 C12.406,12.865 12.214,13.003 11.999,13.003 L8.499,13.003 L8.499,23.503 C8.5,23.779 8.276,24.002 8,24.002 Z M5.5,23.002 L7.5,23.002 L7.5,12.502 C7.5,12.226 7.724,12.002 8,12.002 L11.64,12.002 L12.307,10.002 L8,10.002 C7.724,10.002 7.5,9.778 7.5,9.502 L7.5,5.502 C7.5,4.124 8.621,3.002 10,3.002 L12.5,3.002 L12.5,1.002 L10,1.002 C7.519,1.002 5.5,3.021 5.5,5.502 L5.5,9.502 C5.5,9.778 5.276,10.002 5,10.002 L1.5,10.002 L1.5,12.002 L5,12.002 C5.276,12.002 5.5,12.226 5.5,12.502 L5.5,23.002 Z",
  id: "Shape"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "14px",
    height: "24px",
    viewBox: "0 0 14 24",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/facebook.aba84602.svg";
export { SvgComponent as ReactComponent };